module.exports = __webpack_public_path__ + "img/guest.324d6c09.png";